import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      //Preparation
      [`${prefix}.Preparation.LayerDepth`]: 'Depth of Layer Tested',
      [`${prefix}.Preparation.NuclearDensityGauge`]: 'Nuclear Density Gauge',
      [`${prefix}.Preparation.NuclearDensityGaugeMakeAndModel`]: 'Nuclear Density Gauge Make/Model',
      [`${prefix}.Preparation.DensityStandardCount`]: 'Density Standard Count',
      [`${prefix}.Preparation.MoistureStandardCount`]: 'Moisture Standard Count',
      [`${prefix}.Preparation.TestNumber`]: 'Test Number',
      //Measurements
      [`${prefix}.Measurements.CalculateDensityResult`]: 'Calculate density result from count ratio and calibration',
      [`${prefix}.Measurements.Depth`]: 'Probe Depth',
      [`${prefix}.Measurements.NuclearDensityGaugeMode`]: 'Nuclear Density Gauge Mode',
      [`${prefix}.Measurements.CalibrationEquation`]: 'Calibration Equation',
      [`${prefix}.Measurements.WetDensity`]: 'Wet Density',
      [`${prefix}.Measurements.GaugeMoistureContentDeterminedBy`]: 'Gauge Moisture Content Determined',
      [`${prefix}.Measurements.MoistureDensity`]: 'Moisture Density',
      [`${prefix}.Measurements.MoistureContent`]: 'Gauge Moisture Content',

      //Readings
      [`${prefix}.Measurements.Readings.DensityTestCount`]: 'Test Density Count',
      [`${prefix}.Measurements.Readings.MoistureTestCount`]: 'Test Moisture Count',
      [`${prefix}.Measurements.Readings.DensityCountRatio`]: 'Density Count Ratio',
      [`${prefix}.Measurements.Readings.MoistureCountRatio`]: 'Moisture Count Ratio',

      [`${prefix}.AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent`]: 'Moisture Content',
      [`${prefix}.LabMoistureContent`]: 'Moisture Content',

      [`${prefix}.Results.InsituMoistureContent`]: 'Field Moisture Content',
      [`${prefix}.Results.InsituDryDensity`]: 'Field Dry Density',
      [`${prefix}.Results.InsituWetDensity`]: 'Wet Density',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Measurements.Readings.MoistureContentMeasured`]: '%',
      [`${prefix}.Measurements.MoistureContent`]: '%',
      [`${prefix}.AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent`]: '%',
      [`${prefix}.LabMoistureContent`]: '%',
      [`${prefix}.Results.InsituMoistureContent`]: '%',
    })
  );

export default getLabelConfig;
